"use client";

import { useSyncExternalStore } from "react";
import { useTranslations } from "next-intl";

function subscribe() {
    return () => {};
}

function getIsMac(): boolean {
    return navigator.platform.toLowerCase().includes("mac");
}

export default function PaletteHint() {
    const isMac = useSyncExternalStore(subscribe, getIsMac, () => true);
    const t = useTranslations("palette");

    const open = () => {
        const ev = new KeyboardEvent("keydown", {
            key: "k",
            metaKey: isMac,
            ctrlKey: !isMac,
            bubbles: true,
        });
        window.dispatchEvent(ev);
    };

    return (
        <button
            type="button"
            onClick={open}
            aria-label={`${isMac ? "⌘K" : "Ctrl K"} · ${t("label")}`}
            title={isMac ? "⌘K" : "Ctrl K"}
            className="hidden items-center gap-2 rounded-md border border-input bg-card px-2.5 py-1.5 text-xs text-muted-foreground transition-colors hover:text-foreground sm:inline-flex"
        >
            <svg
                aria-hidden
                viewBox="0 0 20 20"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="h-3.5 w-3.5"
            >
                <circle cx="9" cy="9" r="6" />
                <path d="m17 17-3.5-3.5" />
            </svg>
            <kbd className="font-mono">{isMac ? "⌘K" : "Ctrl K"}</kbd>
        </button>
    );
}
